import { Box, Flex, font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { COLORS } from '@lemonade-hq/tokens';
import styled, { css } from 'styled-components';

export const PageWrapper = styled(Box)`
  overflow: hidden;
`;

export const adjustContentVisibility = css`
  content-visible: auto;
  content-intrinsic-size: auto 1000px;
`;

export const Section = styled(Flex).attrs({
  as: 'section',
})<{ darkBackground?: boolean }>`
  flex-direction: column;
  align-items: center;
  background-color: ${({ darkBackground }: { darkBackground?: boolean }) =>
    darkBackground ? COLORS.cloud : COLORS.white};
  ${({ showTopBorder }) =>
    showTopBorder &&
    css`
      border-top: 1px solid ${themedColor('glass')};
    `}
  ${({ showBottomBorder }) =>
    showBottomBorder &&
    css`
      border-bottom: 1px solid ${themedColor('glass')};
    `}
`;

export const MainHeader = styled.h1`
  text-wrap: balance;
  ${font('alt', { fontSize: '2.8rem', lineHeight: '36px' })};
  text-align: center;

  ${MEDIA_QUERIES.tabletAndDesktop`
    font-size: 5.5rem;
    line-height: 1.3;
  `}
`;

export const SectionTitle = styled.h2`
  text-align: center;
  padding: 0 1rem;
  text-wrap: balance;
  ${font('main', {
    fontSize: '2.8rem',
    lineHeight: '3.6rem',
    fontWeight: 700,
  })};

  ${MEDIA_QUERIES.tabletAndDesktop`
    white-space: pre;
    text-wrap: balance;
    ${font('main', {
      fontSize: '4.4rem',
      lineHeight: '5.6rem',
      fontWeight: 700,
    })};
  `}
`;

export const SectionParagraph = styled.p`
  text-align: center;
  white-space: normal;
  text-wrap: balance;
  ${font('main', { fontSize: '1.8rem', lineHeight: '28px' })};

  ${MEDIA_QUERIES.tabletAndDesktop`
    white-space: pre-line;
  `}

  a {
    text-decoration: underline !important;
  }
`;

export const Divider = styled(Box)`
  height: 1px;
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  display: block;
  background: ${themedColor('glass')};
`;
